import { api } from './client';

export type ServerRole =
  | 'proxy' | 'search' | 'mgmt' | 'app' | 'broker' | 'db'
  | 'camunda' | 'customer_smtp' | 'customer_ad' | 'other';

export const SERVER_ROLE_LABEL: Record<ServerRole, string> = {
  proxy: 'Proxy', search: 'Search', mgmt: 'Mgmt', app: 'App', broker: 'Broker',
  db: 'DB', camunda: 'Camunda', customer_smtp: 'Customer SMTP',
  customer_ad: 'Customer AD', other: 'Прочее',
};

export interface InstServer {
  id: string;
  installation_id: string;
  role: ServerRole;
  name?: string | null;
  ip?: string | null;
  port?: number | null;
  os?: string | null;
  os_version?: string | null;
  vcpu?: number | null;
  ram_gb?: number | null;
  disk_gb?: number | null;
  ssh_user?: string | null;
  ssh_password?: string | null;
  ssh_key?: string | null;
  smtp_user?: string | null;
  smtp_password?: string | null;
  auth_user?: string | null;
  auth_password?: string | null;
  auth_domain?: string | null;
  notes?: string | null;
  created_at: string;
  updated_at: string;
}

export type InstServerIn = Omit<InstServer, 'id' | 'installation_id' | 'created_at' | 'updated_at'>;

export interface InstIntegration {
  id: string;
  installation_id: string;
  kind?: string | null;
  name: string;
  version?: string | null;
  ip?: string | null;
  port?: number | null;
  cred_user?: string | null;
  cred_password?: string | null;
  notes?: string | null;
  created_at: string;
  updated_at: string;
}

export type InstIntegrationIn = Omit<InstIntegration, 'id' | 'installation_id' | 'created_at' | 'updated_at'>;

export interface InstContact {
  id: string;
  installation_id: string;
  full_name: string;
  role?: string | null;
  phone?: string | null;
  email?: string | null;
  telegram?: string | null;
  max_username?: string | null;
  notes?: string | null;
  created_at: string;
  updated_at: string;
}

export type InstContactIn = Omit<InstContact, 'id' | 'installation_id' | 'created_at' | 'updated_at'>;


export const instInvApi = {
  // Servers
  servers: (instId: string, reveal = false) =>
    api.get<InstServer[]>(`/api/v1/installations/${instId}/servers`,
      { params: reveal ? { reveal: true } : {} }).then(r => r.data),
  serverCreate: (instId: string, payload: InstServerIn) =>
    api.post<InstServer>(`/api/v1/installations/${instId}/servers`, payload).then(r => r.data),
  serverUpdate: (instId: string, id: string, payload: Partial<InstServerIn>) =>
    api.patch<InstServer>(`/api/v1/installations/${instId}/servers/${id}`, payload).then(r => r.data),
  serverDelete: (instId: string, id: string) =>
    api.delete(`/api/v1/installations/${instId}/servers/${id}`).then(r => r.data),

  // Integrations
  integrations: (instId: string, reveal = false) =>
    api.get<InstIntegration[]>(`/api/v1/installations/${instId}/integrations`,
      { params: reveal ? { reveal: true } : {} }).then(r => r.data),
  integrationCreate: (instId: string, payload: InstIntegrationIn) =>
    api.post<InstIntegration>(`/api/v1/installations/${instId}/integrations`, payload).then(r => r.data),
  integrationUpdate: (instId: string, id: string, payload: Partial<InstIntegrationIn>) =>
    api.patch<InstIntegration>(`/api/v1/installations/${instId}/integrations/${id}`, payload).then(r => r.data),
  integrationDelete: (instId: string, id: string) =>
    api.delete(`/api/v1/installations/${instId}/integrations/${id}`).then(r => r.data),

  // Contacts
  contacts: (instId: string) =>
    api.get<InstContact[]>(`/api/v1/installations/${instId}/contacts`).then(r => r.data),
  contactCreate: (instId: string, payload: InstContactIn) =>
    api.post<InstContact>(`/api/v1/installations/${instId}/contacts`, payload).then(r => r.data),
  contactUpdate: (instId: string, id: string, payload: Partial<InstContactIn>) =>
    api.patch<InstContact>(`/api/v1/installations/${instId}/contacts/${id}`, payload).then(r => r.data),
  contactDelete: (instId: string, id: string) =>
    api.delete(`/api/v1/installations/${instId}/contacts/${id}`).then(r => r.data),
};
